// src/components/steps/BudgetStep.js
import React from 'react';
import {
  VStack,
  Text,
  Box,
  Button,
  SimpleGrid,
  HStack,
} from '@chakra-ui/react';
import { CircleDollarSign, Sparkles, PiggyBank } from 'lucide-react';

const budgetOptions = [
  {
    value: '60k',
    label: '6万台のランドセル',
    icon: <PiggyBank size={32} strokeWidth={1.5} />,
    color: 'green.400'
  },
  {
    value: '70k',
    label: '7万台のランドセル',
    icon: <CircleDollarSign size={32} strokeWidth={1.5} />,
    color: 'blue.400'
  },
  {
    value: 'all',
    label: '特になし',
    icon: <Sparkles size={32} strokeWidth={1.5} />,
    color: 'purple.400'
  }
];

const BudgetStep = ({ formData, onChange }) => (
  <VStack spacing={{ base: 6, md: 8 }} align="stretch">
    <Text
      fontSize={{ base: "xl", md: "2xl" }}
      fontWeight="bold"
      textAlign="center"
      bgGradient="linear(to-r, green.400, purple.400)"
      bgClip="text"
      mb={{ base: 4, md: 6 }}
    >
      ご希望の価格帯を教えてください
    </Text>

    <SimpleGrid 
      columns={1} 
      spacing={{ base: 3, md: 4 }}
    >
      {budgetOptions.map((option) => (
        <Button
          key={option.value}
          onClick={() => onChange({
            target: { name: 'price', value: option.value }
          })}
          height="auto"
          p={{ base: 4, md: 6 }}
          bg={formData.price === option.value ? option.color : 'white'}
          color={formData.price === option.value ? 'white' : 'gray.600'}
          _hover={{ 
            bg: option.color, 
            color: 'white',
            transform: 'translateY(-2px)',
            transition: 'all 0.2s'
          }}
          border="2px"
          borderColor={option.color}
          borderRadius="xl"
        >
          <HStack 
            spacing={4} 
            width="100%" 
            justify="flex-start"
          >
            <Box 
              color={formData.price === option.value ? 'white' : option.color}
              transition="all 0.2s"
            >
              {option.icon}
            </Box>
            <Text 
              fontSize={{ base: "md", md: "lg" }} 
              fontWeight="bold"
            >
              {option.label}
            </Text>
          </HStack>
        </Button>
      ))}
    </SimpleGrid>

    <Box
      mt={{ base: 4, md: 6 }}
      p={{ base: 4, md: 6 }}
      bg="green.50"
      borderRadius="xl"
      borderLeft="4px"
      borderColor="green.400"
    >
      <Text 
        color="green.600"
        fontSize={{ base: "sm", md: "md" }}
      >
        ご予算に応じて、最適なランドセルを見つけるお手伝いをします。
        価格だけでなく、品質や機能性なども考慮して選定いたします。
      </Text>
    </Box>
  </VStack>
);

export default BudgetStep;